module.exports = __webpack_public_path__ + "img/meetings-events-icon.2aa8848f.svg";